import Lottie from 'lottie-react';
import loadingAnimation from '../../../lottie/Loading-lottie.json';
import './AppLoader.css';

export const AppLoader = ({
  message,
  size = 160,
  className = '',
  variant = 'inline',
}) => {
  const wrapClass = [
    'app-loader',
    variant === 'portal' ? 'app-loader--portal' : '',
    variant === 'page' ? 'app-loader--page' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={wrapClass} role="status" aria-live="polite" aria-busy="true">
      <Lottie
        animationData={loadingAnimation}
        loop
        className="app-loader__lottie"
        style={{ width: size, height: size * 0.5625 }}
      />
      {message ? <p className="app-loader__message">{message}</p> : null}
    </div>
  );
};
